namespace appn.views.connections.index {
    enum SharePointAuthType {
        UserAccount = 'UserAccount',
        AppOnlyPrincipal = 'AppOnlyPrincipal'
    }

    interface OAuth2UrlParams {
        returnAction: string;
        returnController: string;
        returnState: string;
    }

    class InitArgs {
        oAuth2Box: string = emptyString;
        oAuth2Dropbox: string = emptyString;
        oAuth2Egnyte: string = emptyString;
        oAuth2GeoOp: string = emptyString;
        oAuth2Google: string = emptyString;
        oAuth2Microsoft: string = emptyString;
        oAuth2MicrosoftGraph: string = emptyString;
        oAuth2PowerBi: string = emptyString;
        oAuth2Salesforce: string = emptyString;
        oAuth2NetSuite: string = emptyString;
        oAuth2Snowflake: string = emptyString;
        oAuth2Xero: string = emptyString;
        oAuth2Rest: string = emptyString;
        oAuth2ArcGis: string = emptyString;
        oAuth2QuickBooksOnline: string = emptyString;
        connectionsValidateXXXConnection: string = emptyString;
        googleAccessTokenUrl: string = emptyString;
        initPicker: boolean = false;
    }

    let _initArgs: InitArgs;

    export function init(args: InitArgs): void {
        _initArgs = args;

        if (appn.utils.getUrlParamByName('showCon'))
            $('#addConnection').click();

        if (_initArgs.initPicker) {
            setTimeout(() => {
                gapi.client.load('drive', 'v2');
                gapi.load('picker', () => { });
            }, 1000);
        }

        addEvents();
        initKeyValueTables();

        // Validate connections on page load
        $('.connection-card').each(function() {
            ajaxValidateConnection($(this));
        });

        select.init();
    }

    function addEvents(): void {
        $('.connectorOption').on('click', function() {
            if ($(this).data('upgrade-required')) {
                $('#upgradeReqd').modal('show');
                return;
            }

            if ($(this).data('gf-required')) {
                $('#upgradeGFReqd').modal('show');
                return;
            }

            const form = $('form#appnForm');

            form.append('<input type="hidden" name="submitType" value="' + $(this).attr('id') + '" />');
            (form.validate() as any).cancelSubmit = true;
            form.submit();
        });

        $('.btn-clone-connect').on('click', function(event) {
            if ($(this).data('gf-required')) {
                event.preventDefault();

                $('#upgradeGFReqd').modal('show');
            }
        });

        $('.editSecretKey').click(function(event) {
            event.preventDefault();

            // All password-like text boxes in connections are handled by this
            const connectionCard = $(this).closest('.connection-card');

            connectionCard.find('.maskedSecretKey').hide();
            connectionCard.find('.editSecretKey').hide();
            connectionCard.find('.input-secretkey').fadeIn();
        });

        $(document).on('click', '.buildIcon', function (this: HTMLElement, e: Event) {
            e.preventDefault();
            const formulaBox = $(this).closest('div.input-group-sm').find('input');
            appn.ui.formulabuilder.currentFormula = formulaBox.val() as string;
            appn.ui.formulabuilder.currentMode = $(this).data('type');
            appn.ui.formulabuilder.requiresDesignerJson = false;
            appn.ui.formulabuilder.formulaUpdated = function (formula: string) {
                formulaBox.val(formula);
                formulaBox.trigger('change');
                formulaBox.trigger('keyup');
            };
            appn.ui.formulabuilder.showDialog();
        });

        // Connector specific events
        addAwsEvents();
        addBoxEvents();
        addDropboxEvents();
        addEgnyteEvents();
        addGeoOpEvents();
        addGoogleEvents();
        addMicrosoftEvents();
        addPowerBiEvents();
        addSalesforceEvents();
        addSharePointEvents();
        addNetSuiteEvents();
        addSnowflakeEvents();
        addXeroEvents();
        addMicrosoftGraphEvents();
        addFtpEvents();
        addRestEvents();
        addArcGisEvents();
        addQuickBooksOnlineEvents();

        $('.btnTryAddConnector').off().on('click', function(event) {
            event.preventDefault();
            $('#addConnection').click();
        });

        $((document as any)).find('.show-copy-sql-dialog-integration').off().on('click', function(event) {
            event.preventDefault();

            const buttonConfig = {
                copy: {
                    label: T('COPY SQL') + ' <i class="fa fa-copy"></i>',
                    className: 'btn-warning',
                    callback: function(result: any) {
                        if (result) {
                            const copyText = document.getElementsByClassName('show-copy-sql-dialog-integration-msg')[0];
                            (copyText as any).select();
                            document.execCommand('copy');
                        }
                    }
                }
            };
            const text = `CREATE SECURITY INTEGRATION YOUR_INTEGRATION_NAME
    ENABLED = TRUE
    TYPE = OAUTH
    OAUTH_CLIENT = CUSTOM
    OAUTH_CLIENT_TYPE = 'CONFIDENTIAL'
    OAUTH_ISSUE_REFRESH_TOKENS = TRUE
    OAUTH_REDIRECT_URI = '${$(this).closest('.card').find('div[class$="callback-url"]').text().trim()}'`; // Select current event target parent first, then look inside for the correct text
            const msg = elementBuilder.createElement('textarea', 'form-control form-control-sm show-copy-sql-dialog-integration-msg', undefined, [['rows', '10'], ['readonly','']], text, true);
            appn.dialog.custom({
                modalColor: 'modal-info',
                title: T('Copy Integration Commands'),
                message: msg,
                className: '',
                closeButton: true,
                buttons: buttonConfig
            });
        });

        $((document as any)).find('.show-copy-sql-dialog-authentication').off().on('click', function(event) {
            event.preventDefault();

            const buttonConfig = {
                copy: {
                    label: '<span>' + T('COPY SQL') + '</span><i class="fa fa-copy"></i>',
                    className: 'btn-warning',
                    callback: function(result: any) {
                        if (result) {
                            const copyText = document.getElementsByClassName('show-copy-sql-dialog-authentication-msg')[0];
                            (copyText as any).select();
                            document.execCommand('copy');
                        }
                    }
                }
            };
            const text = `SELECT SYSTEM$SHOW_OAUTH_CLIENT_SECRETS( 'YOUR_INTEGRATION_NAME' );`;
            const msg = elementBuilder.createElement('textarea', 'form-control form-control-sm show-copy-sql-dialog-authentication-msg', undefined, [['rows', '2'], ['readonly', '']], text, true);
            appn.dialog.custom({
                modalColor: 'modal-info',
                title: T('Copy Authentication Commands'),
                message: msg,
                className: '',
                closeButton: true,
                buttons: buttonConfig
            });
        });

        // Google Picker;
        $('.btn-google-picker').on('click', function (e) {
            e.preventDefault();
            const connection = $(this).closest('.connection-card');
            const connectionId = connection.data('connection-id');
            const pickerId = connection.find('[id$="_PickerId"]');
            const pickerName = connection.find('.google-picker-name');
            const pickerBtn = connection.find('.btn-google-picker');
            const isSharedFile = connection.find('[id$="_IsSharedDriveFolder"]');

            $.ajax({
                headers: appn.verifyHeader,
                url: _initArgs.googleAccessTokenUrl,
                type: 'POST',
                data: { connId: connectionId },
                success: function (data, status, xhttp) {
                    const response = JSON.parse(data);
                    var view = new google.picker.DocsView()
                        .setIncludeFolders(true)
                        .setMimeTypes('application/vnd.google-apps.folder')
                        .setSelectFolderEnabled(true);

                    this.picker = new google.picker.PickerBuilder()
                        .setAppId(response.ClientId)
                        .setOAuthToken(response.accessToken)
                        .setTitle("Choose Folder")
                        .addView(view)
                        .setCallback(function (data) {
                            if (data[google.picker.Response.ACTION] == google.picker.Action.PICKED) {
                                var file = data[google.picker.Response.DOCUMENTS][0];
                                var id = file[google.picker.Document.ID];
                                const isShared = (file as any).isShared;
                                pickerId.val(id);
                                pickerName.val(file.name);
                                if (isShared)
                                    isSharedFile.val(isShared);
                            }
                        })
                        .build()
                        .setVisible(true);
                },
                error: function (data, message, message2) {
                    appn.toast.notify(toast.Type.error, T('Could not fetch access token.'));
                }
            });
        });
    }

    function initKeyValueTables() {
        $(document).on('click', '.kv-table-add-item', function (event) {
            event.preventDefault();

            const kvTableId = '#' + $(this).data('kvTableId');
            const kvTable = $(kvTableId);
            const propName = kvTable.data('kvPropName');
            const isSecretsEnabled = kvTable.data('kvEnableSecrets');
            const isBuilderEnabled = kvTable.data('kvEnableBuilder');
            const propId = propName.replaceAll('.', '_');
            const kvTableBody = kvTable.find('.kv-table-body');
            const index = kvTableBody.find('tr.kv-table-indexed-row').length;

            const keyColumn = `<td class="dataCol"><input type="text" class="form-control form-control-sm valid" name="${propName}[${index}].Key"></td>`;
            const valueColumn = isBuilderEnabled
                ? `<td class="dataCol"><div class="input-group-sm input-group"><input type="text" class="form-control" autocomplete="off" name="${propName}[${index}].Val"/><div class="input-group-append"><button class="fa fa-hammer btn-sm btn btn btn-secondary buildIcon" data-type="text" type="button"><i></i></button></div></div></td>`
                : `<td class="dataCol"><input type="text" class="form-control form-control-sm" autocomplete="off" name="${propName}[${index}].Val"></td>`;
            const secretColumn = isSecretsEnabled
                ? `<td class="dataCol">${elementBuilder.buildCheckbox('', 'isSecretCheckbox', `${propId}[${index}]_IsSecret`, elementBuilder.ICheckColor.primary, `${propName}[${index}].IsSecret`, true, false)}</td>`
                : emptyString;
            const closeColumn = `<td class="closeCell">${elementBuilder.buildBtnRemoveRow('kv-table-remove-item')}</td>`

            kvTableBody.append(`<tr class="kv-table-indexed-row" data-kv-table-row-idx="${index}">${keyColumn}${valueColumn}${secretColumn}${closeColumn}</tr>`);
            kvTable.showElement();

            if (isSecretsEnabled)
                appn.ui.checkboxForceOnChanged('.isSecretCheckbox');
        });

        $(document).on('click', '.kv-table-remove-item', function () {
            const kvTable = $(this).closest('.kv-table');
            const kvTableBody = kvTable.find('.kv-table-body');
            const propName = kvTable.data('kvPropName');
            const propId = propName.replaceAll('.', '_');

            $(this).closest('tr').remove();

            kvTableBody.find('tr.kv-table-indexed-row').each(function (index) {
                const row = $(this);
                const previousIdx = row.data('kvTableRowIdx');

                if (previousIdx != index) {
                    row.find(`[name='${propName}[${previousIdx}].Key']`).attr('name', `${propName}[${index}].Key`);
                    row.find(`[data-valmsg-for='${propName}[${previousIdx}].Key']`).attr('data-valmsg-for', `${propName}[${index}].Key`);
                    row.find(`[name='${propName}[${previousIdx}].Val']`).attr('name', `${propName}[${index}].Val`);
                    row.find(`[name='${propName}[${previousIdx}].IsSecret']`).attr('name', `${propName}[${index}].IsSecret`);
                    row.find(`[id='${propId}[${previousIdx}]_IsSecret']`).attr('id', `${propId}[${index}]_IsSecret`);
                    row.find(`[for='${propId}[${previousIdx}]_IsSecret']`).attr('for', `${propId}[${index}]_IsSecret`);
                    row.attr('data-kv-table-row-idx', index);
                    row.data('kvTableRowIdx', index);
                }
            });
        });
    }

    function clearCloseAndSubmitForm(window: Window, win: Window, pollTimer: number) {
        window.clearInterval(pollTimer);
        win.close();
        $('form#appnForm').submit(); // Save any other changes in this page, oauth token will be assigned server-side
    }

    function transformAndBuildQueryString(connectorName: string): string {
        return location.buildQueryString([
            { name: 'returnAction', value: `${connectorName}Callback` },
            { name: 'returnController', value: 'Connections' },
            { name: 'returnState', value: `${requestProvider.id}XXY` }
        ]);
    }

    function addAwsEvents(): void {
        $('.aws-region-select').off().on('change', function () {
            const regionSelect = $(this);
            const region = regionSelect.val();
            const customEndpoint = regionSelect.parents('[data-type="AWS"]').find('.aws-custom-endpoint');
            customEndpoint.toggleClass('d-none', region !== "CUSTOM_S3_ENDPOINT");
        });
    }

    function addBoxEvents(): void {
        $('.boxAuth').on('click', function(event) {
            event.preventDefault();

            let url = _initArgs.oAuth2Box + transformAndBuildQueryString('Box');
            const connectionId = $(this).closest('.connection-card').data('connection-id');

            if (connectionId)
                url = url.replace('XXY', `%7c${connectionId}`);
            else
                url = url.replace('XXY', emptyString);

            const win = window.open(url, 'authwindow', 'width=1024, height=640');
            const pollTimer = window.setInterval(function() {
                try {
                    if (win === null || win === undefined || win.document === undefined)
                        window.clearInterval(pollTimer);

                    if (win && win.document.URL.containsIgnoreCase('Connections/BoxCallback'))
                        clearCloseAndSubmitForm(window, win, pollTimer);

                } catch (error) { /*Don't write ssl issues to console*/ }
            }, 500);
        });
    }

    function addQuickBooksOnlineEvents(): void {
        $('.quickBooksOnlineAuth').on('click', function (event) {
            event.preventDefault();

            let url = _initArgs.oAuth2QuickBooksOnline + transformAndBuildQueryString('QuickBooksOnline');
            const connectionId = $(this).closest('.connection-card').data('connection-id');
            const sandBox = $(this).closest('.connection-card').find('.isSandBox').prop('checked');

            if (connectionId)
                url = url.replace('XXY', `%7c${connectionId}%7c${sandBox}`);
            else
                url = url.replace('XXY', emptyString);


            const win = window.open(url, 'authwindow', 'width=1024, height=640');
            const pollTimer = window.setInterval(function () {
                try {
                    if (!win || !win.document)
                        window.clearInterval(pollTimer);

                    if (win && win.document.URL.containsIgnoreCase('Connections/QuickBooksOnlineCallback'))
                        clearCloseAndSubmitForm(window, win, pollTimer);

                } catch (error) { /*Don't write ssl issues to console*/ }
            }, 500);
        });
    }

    function addDropboxEvents(): void {
        $('.dropboxAuth').on('click', function(event) {
            event.preventDefault();

            let url = _initArgs.oAuth2Dropbox + transformAndBuildQueryString('Dropbox');
            const connectionId = $(this).closest('.connection-card').data('connection-id');

            if (connectionId)
                url = url.replace('XXY', `%7c${connectionId}`);
            else
                url = url.replace('XXY', emptyString);

            const win = window.open(url, 'authwindow', 'width=1024, height=640');
            const pollTimer = window.setInterval(function() {
                if (win === null || win === undefined)
                    window.clearInterval(pollTimer);

                if (win && win.document.URL.containsIgnoreCase('Connections/DropboxCallback'))
                    clearCloseAndSubmitForm(window, win, pollTimer);

            }, 500);
        });

        $('.dropboxRevoke').on('click', function (event) {
            event.preventDefault();
            const connectionId = $(this).closest('.connection-card').data('connection-id');
            const form = $('form#appnForm');
            form.append('<input type="hidden" name="submitType" value="dropboxRevoke|' + connectionId + '" />');
            form.submit();
        });
    }

    function addEgnyteEvents(): void {
        $('.egnyteAuth').on('click', function(event) {
            event.preventDefault();

            let url = _initArgs.oAuth2Egnyte + transformAndBuildQueryString('Egnyte');
            const connectionId = $(this).closest('.connection-card').data('connection-id');

            if (connectionId)
                url = url.replace('XXY', `%7c${connectionId}`);
            else
                url = url.replace('XXY', emptyString);

            const win = window.open(url, 'authwindow', 'width=1024, height=640');
            const pollTimer = window.setInterval(function() {
                if (win === null || win === undefined)
                    window.clearInterval(pollTimer);

                if (win && win.document.URL.containsIgnoreCase('Connections/EgnyteCallback'))
                    clearCloseAndSubmitForm(window, win, pollTimer);

            }, 500);
        });

        $('.egnyteRevoke').on('click', function(event) {
            event.preventDefault();
            let url = _initArgs.oAuth2Egnyte + transformAndBuildQueryString('Egnyte');
            const connectionId = $(this).closest('.connection-card').data('connection-id');
            if (connectionId)
                url = url.replace('XXY', `%7c${connectionId}`);
            else
                url = url.replace('XXY', emptyString);
            const win = window.open(url, 'authwindow', 'width=1024, height=640');
            const pollTimer = window.setInterval(function() {
                try {
                    if (win === null || win === undefined || win.document === undefined)
                        window.clearInterval(pollTimer);
                    if (win && win.document.URL.containsIgnoreCase('Connections/EgnyteCallback'))
                        clearCloseAndSubmitForm(window, win, pollTimer);
                } catch (error) { /*Don't write ssl issues to console*/ }
            }, 500);
        });

    }

    function addGeoOpEvents(): void {
        $('.geoOpAuth').on('click', function(event) {
            event.preventDefault();

            let url = _initArgs.oAuth2GeoOp + transformAndBuildQueryString('GeoOp');
            const connectionId = $(this).closest('.connection-card').data('connection-id');

            if (connectionId)
                url = url.replace('XXY', `%7c${connectionId}`);
            else
                url = url.replace('XXY', emptyString);

            const win = window.open(url, 'authwindow', 'width=640, height=480');
            const pollTimer = window.setInterval(function() {
                if (win === null || win === undefined)
                    window.clearInterval(pollTimer);

                if (win && win.document.URL.containsIgnoreCase('Connections/GeoOpCallback'))
                    clearCloseAndSubmitForm(window, win, pollTimer);

            }, 500);
        });

        $('.geoOpRevoke').on('click', function(event) {
            event.preventDefault();

            // var url = 'https://account.live.com/Consent/Edit?client_id=@(Model.MicrosoftAPIAccess.ClientId)';
            // var win = window.open(url, "authwindow", 'width=900, height=600');
        });
    }

    function addGoogleEvents(): void {
        $('.gAuth').on('click', function(event) {
            event.preventDefault();

            const conn = $(this).closest('.connection-card');

            let url = _initArgs.oAuth2Google + transformAndBuildQueryString('Google');
            const connectionId = conn.data('connection-id');

            if (connectionId)
                url = url.replace('XXY', `%7c${connectionId}`); // Google complains when not done this way
            else
                url = url.replace('XXY', emptyString);

            
            if (conn.find('.restricted').length > 0) {
                appn.dialog.custom({
                    modalColor: 'modal-info',
                    title: T('Change Legacy Connection'),
                    message: 'Are you sure you want to change this connection? <br/><br/>Legacy Google connection support has been discontinued and may cause existing connectors that use this connection to behave differently. <br/>We suggest creating a new Google connection and updating your connector configurations.',
                    closeButton: true,
                    buttons: {
                        trash: {
                            label: '<span>' + T('Re-authenticate') + '</span><i class="fa fa-check"></i>',
                            className: 'btn-success',
                            callback: function (result: any) {
                                if (!result)
                                    return;

                                launchGoogleAuthWindow(url);
                            }
                        }
                    }
                });
            }
            else
                launchGoogleAuthWindow(url);

        });

        function launchGoogleAuthWindow(url: any): void {
            const win = window.open(url, 'authwindow', 'width=640, height=670');
            const pollTimer = window.setInterval(function () {
                if (win === null || win === undefined)
                    window.clearInterval(pollTimer);

                if (win && win.document.URL.containsIgnoreCase('Connections/GoogleCallback'))
                    clearCloseAndSubmitForm(window, win, pollTimer);

            }, 500);
        }

        $('.gRevoke').on('click', function(event) {
            event.preventDefault();

            const url = 'https://accounts.google.com/b/0/IssuedAuthSubTokens';

            window.open(url, 'authwindow', 'width=900, height=600');
        });
    }

    function addMicrosoftEvents(): void {
        $('.microsoftAuth').on('click', function(event) {
            event.preventDefault();

            let url = _initArgs.oAuth2Microsoft + transformAndBuildQueryString('Microsoft');
            const connectionId = $(this).closest('.connection-card').data('connection-id');

            if (connectionId)
                url = url.replace('XXY', `%7c${connectionId}`);
            else
                url = url.replace('XXY', emptyString);

            const win = window.open(url, 'authwindow', 'width=640, height=620');
            const pollTimer = window.setInterval(function() {
                if (win === null || win === undefined)
                    window.clearInterval(pollTimer);

                if (win && win.document.URL.containsIgnoreCase('Connections/MicrosoftCallback'))
                    clearCloseAndSubmitForm(window, win, pollTimer);

            }, 500);
        });

        $('.microsoftRevoke').on('click', function(event) {
            event.preventDefault();
            const connectionId = $(this).closest('.connection-card').data('connection-id');
            const form = $('form#appnForm');
            form.append('<input type="hidden" name="submitType" value="microsoftRevoke|' + connectionId + '" />');
            form.submit();
        });
    }

    function addMicrosoftGraphEvents(): void {
        $('.microsoftGraphAuth').on('click', function(event) {
            event.preventDefault();

            let url = _initArgs.oAuth2MicrosoftGraph + transformAndBuildQueryString('MicrosoftGraph');
            const connectionId = $(this).closest('.connection-card').data('connection-id');

            if (connectionId)
                url = url.replace('XXY', `%7c${connectionId}`);
            else
                url = url.replace('XXY', emptyString);

            const win = window.open(url, 'authwindow', 'width=640, height=620');
            const pollTimer = window.setInterval(function() {
                if (win === null || win === undefined)
                    window.clearInterval(pollTimer);

                if (win && win.document.URL.containsIgnoreCase('Connections/MicrosoftGraphCallback'))
                    clearCloseAndSubmitForm(window, win, pollTimer);

            }, 500);
        });

        $('.microsoftGraphRevoke').on('click', function (event) {
            event.preventDefault();
            const connectionId = $(this).closest('.connection-card').data('connection-id');
            const form = $('form#appnForm');
            form.append('<input type="hidden" name="submitType" value="microsoftGraphRevoke|' + connectionId + '" />');
            form.submit();
        });

        $('.graphAuthType').on('change', function() {
            $('form#appnForm').valid();
        });
    }

    function addArcGisEvents(): void {
        $('.arcGisAuth').on('click', function (event) {
            event.preventDefault();

            let url = _initArgs.oAuth2ArcGis + transformAndBuildQueryString('ArcGis');
            const connectionId = $(this).closest('.connection-card').data('connection-id');

            if (connectionId)
                url = url.replace('XXY', `%7c${connectionId}`);
            else
                url = url.replace('XXY', emptyString);

            const win = window.open(url, 'authwindow', 'width=640, height=620');
            const pollTimer = window.setInterval(function () {
                if (win === null || win === undefined)
                    window.clearInterval(pollTimer);

                if (win && win.document.URL.containsIgnoreCase('Connections/arcgiscallback'))
                    clearCloseAndSubmitForm(window, win, pollTimer);

            }, 500);
        });
        
        $('.arcGisRevoke').on('click', function (event) {
            event.preventDefault();
            const connectionId = $(this).closest('.connection-card').data('connection-id');
            const form = $('form#appnForm');
            form.append('<input type="hidden" name="submitType" value="arcGisRevoke|' + connectionId + '" />');
            form.submit();
        });

        $('.arcGisAuthType').on('change', function () {
            $('form#appnForm').valid();
            const arcGisConn = $(this).closest('#arcGisConn');
            arcGisConn.find('.authButton').addClass('d-none');

            if ($(this).val() == "Public") {
                // Hide all
                arcGisConn.find('.arcgisclientid').addClass('d-none');
                arcGisConn.find('.arcgisclientsecret').addClass('d-none');
                arcGisConn.find('.arcgiscallback').addClass('d-none');
                arcGisConn.find('.arcgiskey').addClass('d-none');

                // Blank out irrelevant values
                arcGisConn.find('.arcgisclientid input').val(appn.emptyString);
                arcGisConn.find('.arcgisclientsecret input').val(appn.emptyString);
                arcGisConn.closest('.arcgiskey input').val(appn.emptyString);
            }
            else if ($(this).val() == "ApiKey") {
                // Hide
                arcGisConn.find('.arcgisclientid').addClass('d-none');
                arcGisConn.find('.arcgisclientsecret').addClass('d-none');
                arcGisConn.find('.arcgiscallback').addClass('d-none');

                // Show
                arcGisConn.find('.arcgiskey').removeClass('d-none');

                // Blank out irrelevant values
                arcGisConn.find('.arcgisclientid input').val(appn.emptyString);
                arcGisConn.find('.arcgisclientsecret input').val(appn.emptyString);
            }
            else if ($(this).val() == "User") {
                //Hide
                arcGisConn.find('.arcgiskey').addClass('d-none');
                arcGisConn.find('.arcgisclientid').addClass('d-none');
                arcGisConn.find('.arcgisclientsecret').addClass('d-none');

                //Show
                arcGisConn.find('.arcgiscallback').removeClass('d-none');

                // Blank out irrelevant values
                arcGisConn.find('.arcgisclientid input').val(appn.emptyString);
                arcGisConn.find('.arcgisclientsecret input').val(appn.emptyString);
                arcGisConn.closest('.arcgiskey input').val(appn.emptyString);
            }
            else if ($(this).val() == "App") {
                //Hide
                $(this).closest('#arcGisConn').find('.arcgiscallback').addClass('d-none');
                $(this).closest('#arcGisConn').find('.arcgiskey').addClass('d-none');

                //Show
                $(this).closest('#arcGisConn').find('.arcgisclientid').removeClass('d-none');
                $(this).closest('#arcGisConn').find('.arcgisclientsecret').removeClass('d-none');

                // Blank out irrelevant values
                arcGisConn.closest('.arcgiskey input').val(appn.emptyString);
            }
        });
    }

    function addPowerBiEvents(): void {
        $('.powerBIAuth').on('click', function(event) {
            event.preventDefault();

            let url = _initArgs.oAuth2PowerBi + transformAndBuildQueryString('PowerBI');
            const connectionId = $(this).closest('.connection-card').data('connection-id');

            if (connectionId)
                url = url.replace('XXY', `%7c${connectionId}`);
            else
                url = url.replace('XXY', emptyString);

            const win = window.open(url, 'authwindow', 'width=640, height=670');
            const pollTimer = window.setInterval(function() {
                if (!win)
                    window.clearInterval(pollTimer);

                if (win && win.document.URL.containsIgnoreCase('Connections/PowerBICallback'))
                    clearCloseAndSubmitForm(window, win, pollTimer);

            }, 500);
        });
    }

    function addNetSuiteEvents(): void {
        $('.netSuiteAuth').on('click', function(event) {
            event.preventDefault();

            let url = _initArgs.oAuth2NetSuite + transformAndBuildQueryString('NetSuite');
            const connectionId = $(this).closest('.connection-card').data('connection-id');

            if (connectionId)
                url = url.replace('XXY', `%7c${connectionId}`);
            else
                url = url.replace('XXY', emptyString);

            const win = window.open(url, 'authwindow', 'width=1024, height=640');
            const pollTimer = window.setInterval(function() {
                if (win === null || win === undefined)
                    window.clearInterval(pollTimer);

                if (win && win.document.URL.containsIgnoreCase('Connections/NetSuiteCallback'))
                    clearCloseAndSubmitForm(window, win, pollTimer);

            }, 500);
        });
    }

    function addSalesforceEvents(): void {
        $('.salesforceAuth').on('click', function(event) {
            event.preventDefault();

            let url = _initArgs.oAuth2Salesforce + transformAndBuildQueryString('Salesforce');
            const connectionId = $(this).closest('.connection-card').data('connection-id');

            if (connectionId)
                url = url.replace('XXY', `%7c${connectionId}`);
            else
                url = url.replace('XXY', emptyString);

            const win = window.open(url, 'authwindow', 'width=1024, height=640');
            const pollTimer = window.setInterval(function() {
                if (win === null || win === undefined)
                    window.clearInterval(pollTimer);

                if (win && win.document.URL.containsIgnoreCase('Connections/SalesforceCallback'))
                    clearCloseAndSubmitForm(window, win, pollTimer);

            }, 500);
        });
    }

    function addSharePointEvents(): void {
        $('.spAuthType').off().on('change', function() {
            const current = $(this);
            const parentConn = current.parents('[data-type="SharePoint"]');
            const authType = current.val();

            if (authType === SharePointAuthType.AppOnlyPrincipal) {
                parentConn.find('.spUserAccount').addClass('d-none');
                parentConn.find('.spAppOnlyPrincipal').removeClass('d-none');
            } else {
                parentConn.find('.spUserAccount').removeClass('d-none');
                parentConn.find('.spAppOnlyPrincipal').addClass('d-none');
            }
        });
    }

    function addSnowflakeEvents(): void {
        $('.snowflakeAuth').on('click', function(event) {
            event.preventDefault();

            let url = _initArgs.oAuth2Snowflake + transformAndBuildQueryString('Snowflake');
            const connectionId = $(this).closest('.connection-card').data('connection-id');

            if (connectionId)
                url = url.replace('XXY', `%7c${connectionId}`);
            else
                url = url.replace('XXY', emptyString);

            const win = window.open(url, 'authwindow', 'width=1024, height=640');
            const pollTimer = window.setInterval(function() {
                if (win === null || win === undefined)
                    window.clearInterval(pollTimer);

                if (win && win.document.URL.containsIgnoreCase('Connections/SnowflakeCallback'))
                    clearCloseAndSubmitForm(window, win, pollTimer);

            }, 500);
        });

        $('.snowflakeAuthMethod').off().on('change', function() {
            const current = $(this);
            const parentConn = current.parents('[data-type="Snowflake"]');
            const authMethod = current.val(); 
            if (authMethod === 'KeyPair' || authMethod === '1') {
                parentConn.find('.snowflake-oauth-section').addClass('d-none');
                parentConn.find('.snowflake-keypair-section').removeClass('d-none');
            } else {
                parentConn.find('.snowflake-oauth-section').removeClass('d-none');
                parentConn.find('.snowflake-keypair-section').addClass('d-none');
            }
            $('form#appnForm').valid();
        });
 
        $('.snowflakeAuthMethod').trigger('change');
    }

    function addXeroEvents(): void {
        $('.xeroAuth').on('click', function (event) {
            event.preventDefault();

            let url = _initArgs.oAuth2Xero + transformAndBuildQueryString('Xero');
            const connectionId = $(this).closest('.connection-card').data('connection-id');

            if (connectionId)
                url = url.replace('XXY', `%7c${connectionId}`);
            else
                url = url.replace('XXY', emptyString);

            const win = window.open(url, 'authwindow', 'width=600, height=862');
            const pollTimer = window.setInterval(function () {
                try {
                    if (win === null || win === undefined || win.document === undefined)
                        window.clearInterval(pollTimer);

                    if (win && win.document.URL.containsIgnoreCase('Connections/XeroCallback'))
                        clearCloseAndSubmitForm(window, win, pollTimer);

                } catch (error) { /*Don't write ssl issues to console*/ }
            }, 500);
        });
    }

    function addFtpEvents(): void {
        $('.ftp-ftp-encryption').on('change', function () {
            const ftpEncryption = $(this).val();
            const anyCertContainer = $(this).parents('[data-type="FTP"]').find('.ftp-validate-any-certificate-container');
            if (ftpEncryption === 'ExplicitSSL')
                anyCertContainer.removeClass('d-none');
            else
                anyCertContainer.addClass('d-none');
        });
    }

    function addRestEvents(): void {
        function showHideBodyRequest(conn: JQuery<HTMLElement>) {
            const dataType = conn.find('select[id$="Request_Format"]').val() as string;
            const httpVerb = conn.find('select[id$="Request_Verb"]').val() as string;
            const body = conn.find('.request-body');

            if (httpVerb === 'Get') {
                // GET never has a body
                body.val(emptyString);
                body.hideElement();
                return;
            }

            if (dataType === 'Xml' || dataType === 'Json') {
                body.showElement();
                return;
            }

            // URL encoded
            body.val(emptyString);
            body.hideElement();
        }

        function showHideFormData(conn: JQuery<HTMLElement>) {
            const dataType = conn.find('select[id$="Request_Format"]').val() as string;
            const dataValues = conn.find('.formData-request');

            if (dataType === 'UrlEncoded') {
                dataValues.showElement();
                return;
            }

            dataValues.hideElement();
        }

        $('.restAuth').on('click', function (event) {
            event.preventDefault();

            let url = _initArgs.oAuth2Rest + transformAndBuildQueryString('Rest');
            const connectionId = $(this).closest('.connection-card').data('connection-id');

            if (connectionId)
                url = url.replace('XXY', `%7c${connectionId}`);
            else
                url = url.replace('XXY', emptyString);

            const win = window.open(url, 'authwindow', 'width=640, height=620');
            const pollTimer = window.setInterval(function () {
                if (win === null || win === undefined)
                    window.clearInterval(pollTimer);

                if (win && win.document.URL.containsIgnoreCase('Connections/RestCallback'))
                    clearCloseAndSubmitForm(window, win, pollTimer);

            }, 500);
        });

        $('.restRevoke').on('click', function (event) {
            event.preventDefault();
            const connectionId = $(this).closest('.connection-card').data('connection-id');
            const form = $('form#appnForm');
            form.append('<input type="hidden" name="submitType" value="restRevoke|' + connectionId + '" />');
            form.submit();
        });

        $(document).on('click', '.btnRestAddOauth', function (event) {
            event.preventDefault();
            const conn = $(this).closest('.connection-card');
            conn.find('.rest-oauth-group,.btnRestRemoveOauth').showElement();
            conn.find('.btnRestAddOauth').hideElement();
            conn.find('.btnRestAddAuthRequest').hideElement();
            conn.find('input[id$="AuthUrl"]').rules('add', { required:true });
            conn.find('input[id$="TokenUrl"]').rules('add', { required: true });
        });

        $(document).on('click', '.btnRestRemoveOauth', function (event) {
            event.preventDefault();
            const conn = $(this).closest('.connection-card');
            conn.find('.rest-oauth-group,.btnRestRemoveOauth').hideElement();
            conn.find('.btnRestAddOauth,.btnRestAddAuthRequest').showElement();
            conn.find('input[id$="AuthUrl"], input[id$="TokenUrl"]').val(emptyString);
            conn.find('input[id$="AuthUrl"]').rules('remove', 'required');
            conn.find('input[id$="TokenUrl"]').rules('remove', 'required');
        });

        $(document).on('click', '.btnRestAddAuthRequest', function (event) {
            event.preventDefault();
            const conn = $(this).closest('.connection-card');
            conn.find('.restAuthRequestContainer,.btnRestRemoveAuthRequest').showElement();
            conn.find('.btnRestAddAuthRequest,.btnRestAddOauth').hideElement();
            showHideFormData(conn);
            showHideBodyRequest(conn);
            conn.find('textarea[id$="AuthRequest_Url"]').rules('add', { required: true })
        });

        $(document).on('click', '.btnRestRemoveAuthRequest', function (event) {
            event.preventDefault();
            const conn = $(this).closest('.connection-card');
            conn.find('.btnRestAddAuthRequest,.btnRestAddOauth').showElement();
            conn.find('.restAuthRequestContainer,.btnRestRemoveAuthRequest').hideElement();
            conn.find('textarea[id$="AuthRequest_Url"]').val(emptyString);
            conn.find('textarea[id$="AuthRequest_Url"]').rules('remove', 'required');
        });

        $(document).on('change', '.connection-card[data-type="REST"] .httpVerb', function (event) {
            event.preventDefault();
            const conn = $(this).closest('.connection-card');
            showHideBodyRequest(conn);
        });

        $(document).on('change', '.connection-card[data-type="REST"] .formatType', function (event) {
            event.preventDefault();
            const conn = $(this).closest('.connection-card');
            showHideBodyRequest(conn);
            showHideFormData(conn);
        });
    }

    function connectionCheck(connectionCard: any): void {
        const label = connectionCard.find('.statusLabel');
        const icon = connectionCard.find('.statusIcon');
        const details = connectionCard.find('.accountDetails');
        const cardTools = connectionCard.find('.card-tools');

        icon.html(appn.ui.getSpinner());
        label.html(T('Checking Connection...'));
        details.hide();
        cardTools.prepend(appn.ui.getSpinner('spinner-border-sm'));
        connectionCard.find('.statusBox').fadeIn();
    }

    function connectionSuccess(connectionCard: any, info: any): void {
        const label = connectionCard.find('.statusLabel');
        const icon = connectionCard.find('.statusIcon');
        const details = connectionCard.find('.accountDetails');
        const cardTools = connectionCard.find('.card-tools');
        const statusBox = connectionCard.find('.statusBox');
        const statusDetails = connectionCard.find('.statusDetails');
        const cardBody = connectionCard.find('.statusBox .card-body');
        const cardBodyText = connectionCard.find('.statusBox .card-body .statusLabel');

        cardBodyText.addClass('text-success');
        icon.html('<i class="fa fa-check mr-2"></i>'+T('Connected'));
        label.remove();
        icon.addClass('text-success');
        cardTools.find('.appn-spinner').remove();
        cardTools.prepend(`<span class="small"><i class="fa fa-check text-success"></i>&nbsp;${T('Connected')}</span>`);

        if (info !== undefined && info !== null) {
            details.show();

            $.each(info, function(key: string, value: string) {
                if (key.contains('Css')) {
                    const target = connectionCard.find('.' + key.replace('Css', emptyString));
                    const vals = value.split(':');

                    target.css(vals[0], value.replace(vals[0] + ':', emptyString));
                } else if (key.contains('Attr')) {
                    const target = connectionCard.find('.' + key.replace('Attr', emptyString));
                    const vals = value.split(':');

                    target.attr(vals[0], value.replace(vals[0] + ':', emptyString));
                } else {
                    const target = connectionCard.find('.' + key);

                    target.html(value);
                }
            });
        } else
            details.hide();

        if (statusDetails.is(':empty'))
            cardBody.hide();

        connectionCard.find('.statusBox').fadeIn();
    }

    function connectionError(connectionCard: any, errm?: string): void {
        const label = connectionCard.find('.statusLabel');
        const icon = connectionCard.find('.statusIcon');
        const details = connectionCard.find('.accountDetails');
        const cardTools = connectionCard.find('.card-tools');
        const statusBox = connectionCard.find('.statusBox');
        const statusDetails = connectionCard.find('.statusDetails');
        const cardBody = connectionCard.find('.statusBox .card-body');
        const cardBodyText = connectionCard.find('.statusBox .card-body .statusLabel');

        icon.html(`<i class="fa fa-exclamation-triangle mr-2"></i>${T('Error')}`);
        cardTools.find('.appn-spinner').remove();
        icon.addClass('text-danger');
        cardBodyText.addClass('text-danger');
        cardTools.prepend(`<span class=""><i class="fa fa-times text-danger"></i>&nbsp;${T('Cannot Connect')}</span>`);

        if (errm !== null && errm !== undefined && errm.length > 0)
            label.text(errm);
        else
            label.text('Cannot Connect');

        details.hide();

        if (statusDetails.is(':empty') && label.is(':empty'))
            cardBody.hide();

        connectionCard.find('.statusBox').fadeIn();
    }

    function ajaxValidateConnection(connectionCard: any, dataCallback?: Function) {
        // Changes the relevant DOM elements to show that we are checking for valid connection.
        connectionCheck(connectionCard);

        const url = _initArgs.connectionsValidateXXXConnection.replace('XXX', String(connectionCard.data('type')));

        appn.ajax.post({
            url: url,
            data: { id: requestProvider.id, connectionId: String(connectionCard.data('connection-id')) },
            dataType: 'json',
            done: function(data: any) {
                if (data && data.Valid && data.Valid === true) {
                    // Changes the relevant DOM elements to show the connection was successful
                    connectionSuccess(connectionCard, data.AccountInfo);

                    if (dataCallback)
                        dataCallback(data);
                    return;
                }

                // Error if we got here
                connectionError(connectionCard, data.ErrorMessage);

                if (dataCallback)
                    dataCallback(data);
            },
            fail: function(data: any) {
                connectionError(connectionCard, data.statusText);

                if (dataCallback)
                    dataCallback(data);
            }
        });
    }
}
